import { ArrowDownwardRounded } from '@mui/icons-material';
import { Box, BoxProps, IconButton } from '@mui/material';

interface ScrollToBottomButtonProps {
  onClick: () => void;
  containerRef: React.RefObject<HTMLDivElement>;
  containerProps?: BoxProps;
}

export const ScrollToBottomButton = ({
  onClick,
  containerRef,
  containerProps = {},
}: ScrollToBottomButtonProps) => {
  const scrollToBottom = () => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    container.lastElementChild?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
    });
  };

  return (
    <Box
      {...containerProps}
      sx={{
        position: 'absolute',
        left: '50%',
        bottom: 0,
        zIndex: (theme) => theme.zIndex.drawer,
        ...containerProps?.sx,
      }}
    >
      <IconButton
        onClick={() => {
          onClick();
          scrollToBottom();
        }}
        sx={{
          cursor: 'pointer',
          backgroundColor: (theme) => `${theme.palette.action.hover}!important`,
        }}
      >
        <ArrowDownwardRounded />
      </IconButton>
    </Box>
  );
};
